import axios from "axios";
const API_URL = "/api/common";

export const getTermsByClass = (classId) => axios.get(`${API_URL}/terms/${classId}`);
export const getDivisionsByClass = (classId) => axios.get(`${API_URL}/divisions/${classId}`);
export const getSubjectsByClass = (classId) => axios.get(`${API_URL}/subjects/${classId}`);
export const getChaptersByClassDivTermSub = (classId,divisionId,TermId,SubjectId) => axios.get(`${API_URL}/get-chapters-list/${classId}/${divisionId}/${TermId}/${SubjectId}`);
export const getTopicsByChapters = (chapterId) => axios.get(`${API_URL}/get-topics-list/${chapterId}`);